module.exports = __webpack_public_path__ + "img/performance-6.1c0d84b8.png";